import { render, staticRenderFns } from "./MarketingBlock.vue?vue&type=template&id=ad6eb46c&scoped=true"
import script from "./MarketingBlock.vue?vue&type=script&lang=js"
export * from "./MarketingBlock.vue?vue&type=script&lang=js"
import style0 from "./MarketingBlock.vue?vue&type=style&index=0&id=ad6eb46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6eb46c",
  null
  
)

export default component.exports